(function ($) {
	const initializeSlider = ($self) => {
        const $slider = $self.find('.card-slider');
        const slidesCount = $self.find('.splide__slide:not(.splide__slide--clone)').length;

        if(!$slider.length) return;

		new Splide($self.find('.card-slider')[0], {
			type: 'loop',
			arrows: slidesCount > 1,
			pagination: false,
			perPage: 1,
			gap: '20px',
            drag: slidesCount > 1,
			breakpoints: {
				768: {
				  focus: 'center',
				},
			  }
		}).mount();
	}

	$.fn.wysiwygCardSlider = function () {
		return this.each((i, el) => {
			const $self = $(el);
			const $sliderContainer = $self.find('.wcs-slider-container');

			$(window).on("fr:splidejs-loaded", () => {
				initializeSlider($sliderContainer);
			});
		});
	}

	$(() => {
		$('.wysiwyg-card-slider-module').wysiwygCardSlider();
	});
})(jQuery);